import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import { useCreationModal } from './CreateRoleModal';
import RoleList from './RoleList';

const RoleListPage = () => {
    const { t } = useTranslation('roleList');
    const creationModal = useCreationModal();

    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);
    const hasCreatePermission = company
        ? hasPermissions(company.permissions, [permissionKind.createRole]) &&
          hasPermissions(accountPermissions, [permissionKind.createRole])
        : hasPermissions(accountPermissions, [permissionKind.createRole]);

    const extra = (
        <>
            {creationModal.render()}
            {hasCreatePermission && (
                <Button icon={<PlusOutlined />} onClick={creationModal.open} type="primary">
                    {t('roleList:actions.addRole')}
                </Button>
            )}
        </>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('roleList:title')}>
            <RoleList />
        </ConsolePageWithHeader>
    );
};

export default RoleListPage;
